module.exports = __webpack_public_path__ + "static/media/2015_conf_Designing_for_Tomorrows_Smart_Systems.493a49f3.png";